<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import { fly } from 'svelte/transition';
	export let selected: boolean | undefined = false;
	export let selectedBefore: boolean | undefined = false;
	export let number: number;
	export let title: string;
	export let caption: string | null = null;
	export let hideSeparator: boolean | undefined = false;

	$: separatorStyle = !hideSeparator
		? 'after:border-primary after:w-[1px] after:h-14 after:border-dashed lg:after:invisible'
		: '';
</script>

<li
	class="flex flex-col items-center after:border-r-[1px] lg:flex-row lg:items-start lg:gap-x-4 {separatorStyle} cursor-pointer"
>
	<button
		on:click
		class="flex h-12 w-12 shrink-0 grow-0 items-center justify-center rounded-full border-2 border-neutral-400 p-2 text-2xl font-bold text-neutral-400 lg:h-9 lg:w-9 lg:text-xl"
		class:text-primary={selected || selectedBefore}
		class:border-none={selected}
		class:border-primary={selectedBefore}
		class:bg-primary-light={selected}
	>
		{number}
	</button>
	<div
		class="d-flex flex-column w-100 text-sm"
		on:click
		role="button"
		on:keypress={() => null}
		tabindex="0"
	>
		<div class="w-100 hidden gap-1 text-neutral-400 lg:flex lg:flex-col">
			<h3 class:text-dark={selected || selectedBefore}>{@html $__(title)}</h3>
			{#if selectedBefore && caption}
				<h4 transition:fly class="font-semibold text-dark">{@html caption}</h4>
			{/if}
		</div>
		<div
			class:text-second={selected || selectedBefore}
			class:border-none={selected}
			class:border-primary={selectedBefore}
			class="w-100 hidden pt-3 font-bold lg:flex lg:flex-col"
		/>
	</div>
</li>
